import ReportIssue from './component';

export default ReportIssue;
